import React from "react";
import { COMPANY } from "../constant/company_constant";
import "./AppLoader.css";

const AppLoader = () => (
  <main className="app-loader" role="status" aria-live="polite" aria-label="Loading application">
    <div className="app-loader-card">
      <img className="app-loader-logo" src={COMPANY.logo} alt={COMPANY.name} />
      <div className="app-loader-spinner" aria-hidden="true" />
      <strong>Loading your workspace</strong>
      <span>Please wait a moment</span>
    </div>
  </main>
);

export default AppLoader;
